import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/blog/[...slug]/BlogClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["S"] */ "/vercel/path0/node_modules/swr/dist/index/config-12s-Bi4rgVRk.mjs");
